export default __webpack_public_path__ + "static/screenSecondSectionUkBig-fdbee275932f46eb954d7d42136521d0.webp";